var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 15.425C1.06667 15.5583 0.75 15.529 0.45 15.337C0.15 15.1457 0 14.8667 0 14.5V10.775C0 10.5417 0.0666667 10.3333 0.2 10.15C0.333333 9.96666 0.516667 9.84999 0.75 9.79999L8 7.99999L0.75 6.19999C0.516667 6.14999 0.333333 6.03333 0.2 5.84999C0.0666667 5.66666 0 5.45833 0 5.22499V1.49999C0 1.13333 0.15 0.853995 0.45 0.661995C0.75 0.470661 1.06667 0.441661 1.4 0.574994L16.8 7.07499C17.2167 7.25833 17.425 7.56666 17.425 7.99999C17.425 8.43333 17.2167 8.74166 16.8 8.92499L1.4 15.425Z",
    fill: "#A9B2B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.19e35c170279a91dce2e4176e85ada91.svg";
export { ForwardRef as ReactComponent };